import {ActionTree} from 'vuex';
import axios from '@/network/api';
import {AxiosResponse, AxiosError} from 'axios';
import {SystemSettingsState} from '@/models/SystemSettingsState';

export const actions: ActionTree<SystemSettingsState, {}> = {
    fetchSystemSettings({commit}) {
        axios
            .get('/system_settings')
            .then((response: AxiosResponse) => {
                commit('setSystemSettingsData', response.data.settings);
            }).catch((error: AxiosError) => {
            console.log('error');
        });
    },
    clearSystemSettings({commit}) {
        commit('setSystemSettingsData', {});
    },
};
